import React, { useEffect } from 'react';
import { Form } from 'formik';
import FormInput from '../common/FormInput.tsx';
import MapComponent from '../common/map/GoogleMap.tsx';
import RequiredLabel from '../common/RequiredLabel.tsx';
import { AppDispatch, RootState } from '../../store/store.ts';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServices, fetchSubServices, setSelectedServiceId } from '../../slices/VendorSlice.ts';
import { IVendorReq } from '../../type/type.ts';

interface VendorFormProps {
  handleChange: (e: React.ChangeEvent<any>) => void;
  values: IVendorReq;
  touched: { [key: string]: boolean };
  errors: { [key: string]: string };
  setFieldValue: (field: string, value: any) => void;
}

const VendorForm: React.FC<VendorFormProps> = ({
  handleChange,
  values,
  touched,
  errors,
  setFieldValue,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { services, subServices } = useSelector((state: RootState) => state.vendorSlice);
  const { selectedServiceId } = useSelector((state: RootState) => state.vendorSlice);

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  useEffect(() => {
    if (selectedServiceId) {
      dispatch(fetchSubServices(selectedServiceId));
    }
  }, [dispatch, selectedServiceId]);

  const handleServiceChange = (serviceId: number | undefined) => {
    if (serviceId) {
      setFieldValue('service_id', serviceId);
      setFieldValue('sub_service_id', 0);
      dispatch(setSelectedServiceId(serviceId));
    }
  };

  return (
    <Form>
      <p className='text-[#0F44BE] mb-3'>VENDOR INFORMATION</p>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <RequiredLabel>Vendor Name</RequiredLabel>
          <FormInput
            name="name"
            type="text"
            placeholder="Enter Vendor Name"
            onChange={handleChange}
            value={values.name}
            error={touched.name && errors.name}
          />
        </div>
        <div>
          <RequiredLabel>Email ID</RequiredLabel>
          <FormInput
            name="email"
            type="email"
            placeholder="Enter Email"
            onChange={handleChange}
            value={values.email}
            error={touched.email && errors.email}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Mobile Number</RequiredLabel>
          <FormInput
            name="mobile"
            type="number"
            placeholder="Enter mobile Number"
            onChange={handleChange}
            value={values.mobile}
            error={touched.mobile && errors.mobile}
          />
        </div>
        <div>
          <RequiredLabel>Age</RequiredLabel>
          <FormInput
            name="age"
            type="number"
            placeholder="Enter Your Age"
            onChange={handleChange}
            value={values.age}
            error={touched.age && errors.age}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Status</RequiredLabel>
          <FormInput
            name="status"
            type="text"
            placeholder="Enter Status"
            onChange={handleChange}
            value={values.status}
            error={touched.status && errors.status}
          />
        </div>
        <div>
          <RequiredLabel>TFN Number</RequiredLabel>
          <FormInput
            name="TFN_number"
            type="text"
            placeholder="Enter Your TFN Number"
            onChange={handleChange}
            value={values.TFN_number}
            error={touched.TFN_number && errors.TFN_number}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>License Number</RequiredLabel>
          <FormInput
            name="license"
            type="text"
            placeholder="Enter license number"
            onChange={handleChange}
            value={values.license}
            error={touched.license && errors.license}
          />
        </div>
        <div>
          <RequiredLabel>Proof of Age</RequiredLabel>
          <FormInput
            name="proof_of_age"
            type="text"
            placeholder="Enter Your Proof of age"
            onChange={handleChange}
            value={values.proof_of_age}
            error={touched.proof_of_age && errors.proof_of_age}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Passport Number</RequiredLabel>
          <FormInput
            name="passport"
            type="text"
            placeholder="Enter passport number"
            onChange={handleChange}
            value={values.passport}
            error={touched.passport && errors.passport}
          />
        </div>
        <div>
          <RequiredLabel>Address</RequiredLabel>
          <FormInput
            name="address"
            type="text"
            placeholder="Enter Address"
            onChange={handleChange}
            value={values.address}
            error={touched.address && errors.address}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>City</RequiredLabel>
          <FormInput
            name="city"
            type="text"
            placeholder="Enter City"
            onChange={handleChange}
            value={values.city}
            error={touched.city && errors.city}
          />
        </div>
        <div>
          <RequiredLabel>State</RequiredLabel>
          <FormInput
            name="state"
            type="text"
            placeholder="Enter State"
            onChange={handleChange}
            value={values.state}
            error={touched.state && errors.state}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Country</RequiredLabel>
          <FormInput
            name="country"
            type="text"
            placeholder="Enter Country"
            onChange={handleChange}
            value={values.country}
            error={touched.country && errors.country}
          />
        </div>
        <div>
          <RequiredLabel>Pincode</RequiredLabel>
          <FormInput
            name="pincode"
            type="text"
            placeholder="Enter Pincode"
            onChange={handleChange}
            value={values.pincode}
            error={touched.pincode && errors.pincode}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Latitude</RequiredLabel>
          <FormInput
            name="latitude"
            type="text"
            placeholder="Enter Latitude"
            onChange={handleChange}
            value={values.latitude}
            error={touched.latitude && errors.latitude}
            disabled={true}
          />
        </div>
        <div>
          <RequiredLabel>Longitude</RequiredLabel>
          <FormInput
            name="longitude"
            type="text"
            placeholder="Enter Longitude"
            onChange={handleChange}
            value={values.longitude}
            error={touched.longitude && errors.longitude}
            disabled={true}
          />
        </div>
      </div>

      <div className='mt-4'>
        <MapComponent
          onLocationSelect={(location) => {
            setFieldValue("address", location.address);
            setFieldValue("city", location.city);
            setFieldValue("state", location.state);
            setFieldValue("pincode", location.zipcode);
            setFieldValue("latitude", location.lat.toString());
            setFieldValue("longitude", location.lng.toString());
          }}
          initialLat={Number(values.latitude) || undefined}
          initialLng={Number(values.longitude) || undefined}
        />
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <RequiredLabel>Service</RequiredLabel>
          <FormInput
            name="service_id"
            type="select"
            placeholder="Select Service"
            options={services.map((service) => ({ 
              label: service.name, 
              value: service.id 
            }))}
            value={values.service_id}
            onChange={(value: any) => {
              const serviceId = value ? Number(value) : undefined;
              setFieldValue('service_id', serviceId);
              setFieldValue('sub_service_id', undefined);
              if (serviceId) {
                dispatch(setSelectedServiceId(serviceId));
              }
            }}
            error={touched.service_id && errors.service_id}
          />
        </div>

        <div>
          <RequiredLabel>Sub Service</RequiredLabel>
          <FormInput
            name="sub_service_id"
            type="select"
            placeholder="Select Sub Service"
            options={Array.isArray(subServices)
              ? subServices
                  .filter((subService) => subService.service_id === values.service_id)
                  .map((subService) => ({ 
                    label: subService.subservice_name, 
                    value: subService.id 
                  }))
              : []}
            value={values.sub_service_id}
            onChange={(value: any) => {
              setFieldValue('sub_service_id', value ? Number(value) : undefined);
            }}
            error={touched.sub_service_id && errors.sub_service_id}
            disabled={!values.service_id}
          />
        </div>
      </div>
    </Form>
  );
};

export default VendorForm;
